module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og sørsamisk_primærlogo_neg(hvit).9538b389.svg";